// import { TokenResponse } from "@react-oauth/google";
import { User } from "src/model_types/user.types";
import { backendApi } from "../api";

// Define the new endpoints
const userEndpoints = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    getSelf: builder.query<User, void>({
      query: () => ({
        url: `user`,
        method: "GET",
      }),
    }),
    getUser: builder.query<User, string | undefined>({
      query: (_id?) => ({
        url: `/user/${_id}`,
        method: "GET",
      }),
    }),
    updateUser: builder.mutation<User, Partial<User>>({
      query: ({ _id, ...data }) => {
        return { url: "/user", method: "PATCH", data };
      },
    }),
    changeProfilePicture: builder.mutation({
      query: ({ file }: { file: File }) => {
        const formData = new FormData();
        formData.append("photo", file);
        return {
          url: `/user/profile-photo`,
          method: "PATCH",
          data: formData,
        };
      },
      invalidatesTags: (result, error) => [
        // { type: "Homes", id: String(metaData.homeId) }, // Invalidate the specific home
        { type: "Users", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
    uploadStudentID: builder.mutation({
      query: ({ file }: { file: File }) => {
        const formData = new FormData();
        formData.append("photo", file);
        return {
          url: `/user/student-id`,
          method: "PATCH",
          data: formData,
        };
      },
      invalidatesTags: (result, error) => [
        { type: "Users", id: "LIST" }, // Invalidate list queries, if applicable
      ],
    }),
    deleteUser: builder.mutation<void, string>({
      query: () => ({
        url: `user`,
        method: "DELETE",
      }),
    }),
    requestContact: builder.mutation<void, string>({
      query: (id) => ({
        url: `/user/${id}/request-contact`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Homes", id: String(id) },
      ],
    }),
    acceptContact: builder.mutation<void, string>({
      query: (id) => ({
        url: `/user/${id}/accept-contact`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Homes", id: String(id) },
      ],
    }),
  }),
});

// Export the hooks for the new endpoints
export const {
  useAcceptContactMutation,
  useChangeProfilePictureMutation,
  useGetSelfQuery,
  useGetUserQuery,
  useRequestContactMutation,
  useUpdateUserMutation,
  useUploadStudentIDMutation,
} = userEndpoints;
